import Swiper from "swiper";
import { A11y, FreeMode, Navigation } from "swiper/modules";
import { fireEvent } from "@/scripts/common/util";
import { animate } from "motion";
import { prefersReducedMotion } from "@/scripts/common/util";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".element-timeline").forEach((el) => {
    const container = el.querySelector(".swiper");
    const numSlides = container.querySelectorAll(".swiper-slide").length;
    const dateHolder = el.querySelector(".timeline-item-date span");

    new Swiper(container, {
      modules: [A11y, FreeMode, Navigation],
      slidesPerView: "auto",
      speed: 750,
      spaceBetween: 0,
      centerInsufficientSlides: numSlides != 2,
      centeredSlides: numSlides >= 2,
      freeMode: {
        enabled: true,
        momentumRatio: 0.8,
        sticky: true,
      },
      navigation: {
        nextEl: el.querySelector(".slider-button-next"),
        prevEl: el.querySelector(".slider-button-prev"),
      },
      breakpoints: {
        1536: {
          spaceBetween: 32,
        },
      },
      on: {
        touchMove: (_, event) => {
          fireEvent("swiper:drag", document.documentElement, event);
        },
        touchEnd: (_, event) => {
          fireEvent("swiper:dragend", document.documentElement, event);
        },
        resize: (swiper) => {
          if (swiper.isLocked) {
            swiper.el.querySelector(".swiper-wrapper").removeAttribute("data-cursor-content");
          } else {
            swiper.el.querySelector(".swiper-wrapper").setAttribute("data-cursor-content", "Drag");
          }
        },
        slideChange: async (swiper) => {
          if (!prefersReducedMotion) {
            await animate(dateHolder, { y: 10, opacity: 0 }, { duration: 0.4 }).finished;
          }

          const activeSlide = swiper.slides[swiper.activeIndex];
          const date = activeSlide.dataset.date;

          dateHolder.textContent = date;

          if (!prefersReducedMotion) {
            animate(dateHolder, { y: 0, opacity: 1 });
          }
        },
      },
    });
  });
});
